// Site Configurations for Collect Renaissance
// -- These values are unique for each site and rarely need to be changed after initial setup
// -- They are passed to the coreContext in _app.tsx and can be accessed in hah-fe-core via the useContext hook

import type { RumConfig } from '@Hotels-at-Home/hah-fe-core/dist/hooks/useRumScript';

export const csrEmail = 'customer.service@collectrenaissance.com';
export const siteName = 'Collect Renaissance'; // Used in meta tags, for copy interpolation, etc.
export const parentHotelCompany = 'Marriott';
export const hotelBrandName = 'Renaissance Hotels';
export const catalogId = 'RHR';
export const region = 'EU';
export const scandiWebMenuId = 'rhr';
export const companyTelephone = '+33 1 41 51 54 26';

export const LOGO_IMAGE = { src: '/images/misc/renaissance-logo.svg', alt: '' };

// Product/Category Page Settings
// - imageWidth/imageHeight set the size of the <img /> on cat/prod pages to prevent layout shift
export const product = {
  imageWidth: 1200,
  imageHeight: 933,
  imageWidthThumbnail: 500,
  almaWidget: true,
};

export const category = {
  imageEagerLoadingAmount: 3,
};

export const cart = {
  counterButtons: true,
  drawerContinueShopping: false,
  useCartDrawer: true,
  staticQuantity: true,
  ymalName: 'RHREU - Cart',
  disableCartYmals: true,
  drawerTotalInBUtton: false,
};

export const checkout = {
  placeholderLabels: true,
  radioButtons: true,
  paymentMethodProceedButton: true,
};

export const header = {
  leftDrawerUtilities: true,
};

// Misc
export const firstVisitModal = {
  modalWidth: 550,
};

// Adobe Launch Settings
// - Remove these lines completely if this is not a Marriott site
export const enableBonvoyNumber = true;
export const enableMarriottAdobeLaunch = true;
export const enableBonvoyLoyaltyProgramme = true;
export const account = {
  disableAccountDrawer: false,
  enableWelcomeMessage: true,
};
export const marriottAdobeLaunchBrandCode = 'RHR';
export const marriottAdobeLaunchBrandName = 'Renaissance Hotels';

// Google Tag Manager & Analytics Settings
export const enableGoogleTagManager = true;
export const googleTagManagerId = 'GTM-KJVCWDP';
export const productNameFilters = {
  replacements: [{ target: 'The Marriott', replacement: 'Marriott' }],
  splits: [{ split: ' - ', keepIndex: 0 }],
};

// Zendesk Web Widget
export const zendeskKey = 'ff2f07b9-5f51-4b12-a3b6-8944ddcac090';

// AppMonitor ID and identity pool ID are public identifiers (they ship in the client
// bundle); see cloudwatch-rum-gdpr-investigation.md in hah-docs for rationale.
export const cloudWatchRum: RumConfig = {
  applicationId: '47c3fddc-c18b-45a7-9a36-ace7a0de944a',
  region: 'eu-central-1',
  identityPoolId: 'eu-central-1:9a1b3829-11c8-4a06-b474-df9fd49dc0d1',
};

// Cookie Restorer for Safari ITP
export const cookieRestorerEnabled = true;
export const cookieRestorerOptions = { options: { interval: 5000 } };

// Meta Tags
export const googleSiteVerification = 'rTuzoeqK2xbCAQ9JM4h5LP8uIpqzPm6GVEh2-3boTTE';
export const defaultOgImage = '/images/homepage/heroSection/renaissance-hero-mob.jpg';

// Links to international sites
export const INTL_SITES = [
  {
    region: 'NA',
    links: [{ value: 'U.S.A.', url: 'https://shop.marriott.com/brands/renaissance' }],
  },
];
